// The long-tail areas of the admin whose usage is being measured, as one stable
// label that survives route renames and the per-view URL grouping. RUM already
// records a view per page, named by its URL path; this adds a `section` on top
// so "reports", "settings" and "marketplace" can each be counted as one thing.
const SECTIONS: Array<[string, RegExp]> = [
  ["reports", /^\/reports(\/|$)/],
  ["settings", /^\/(company\/settings|settings)(\/|$)/],
  ["marketplace", /^\/marketplace(\/|$)/]
];

export function sectionForPath(path: string | undefined): string | undefined {
  if (!path) return undefined;
  return SECTIONS.find(([, pattern]) => pattern.test(path))?.[0];
}

type RumEvent = { view?: { url?: string }; context?: Record<string, unknown> };

/** Stamp an outgoing RUM event with the section its view belongs to, if any. */
export function addSection<T extends RumEvent>(event: T): T {
  let path: string | undefined;
  try {
    path = event.view?.url ? new URL(event.view.url).pathname : undefined;
  } catch {
    return event;
  }
  const section = sectionForPath(path);
  if (section) event.context = { ...event.context, section };
  return event;
}
